export default function getLocalStoreUser() {
    const loc_user = localStorage.getItem('user');
    const store_user = loc_user && loc_user !== 'undefined' ? JSON.parse(loc_user) : null;
    if (!store_user?._id) {
        return null;
    }
    return store_user;
}
